import { Link } from 'react-router-dom';
import { Card } from '@dma/ui';
import type { ServiceDto } from '../application/dto/ServiceDto';
import './ServiceCard.css';

export interface ServiceCardProps {
  service: ServiceDto;
}

export function ServiceCard({ service }: ServiceCardProps) {
  return (
    <Link to={`/services/${service.slug}`} className="dma-service-card__link">
      <Card className="dma-service-card">
        <h3 className="dma-service-card__title">{service.title}</h3>
        <p className="dma-service-card__summary">{service.summary}</p>
      </Card>
    </Link>
  );
}
